<div [formGroup]="f">
    <div class="expandCollapseContainer mb-1" [ngClass]="!enableFilter ? 'inputDisabled' : 'inputEnabled'">
        <button class="expandCollapseHeader filterButton  mb-1" (click)="onDisplayYearFilter()">
            <strong>{{ 'year' | translate | async }}</strong>
            <ng-container *ngIf="displayYearFilter; else expandIcon">
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-collapse"></use>
            </svg>
            </ng-container>
            <ng-template #expandIcon>
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-expand"></use>
            </svg>
            </ng-template>
        </button>

        <div *ngIf="enableFilter && displayYearFilter">
            <mat-form-field appearance="{{!enableFilter ? 'fill' : 'outline'}}" class="flex-child" color="accent">
                <mat-label>
                    {{ 'year.from' | translate | async }}
                </mat-label>
                <input matInput type="text"
                    [readonly]="!enableFilter"
                    formControlName="yearFrom"
                    [matAutocomplete]="yearFromAuto">
            </mat-form-field>
            
            <mat-autocomplete #yearFromAuto="matAutocomplete">
                <mat-option *ngFor="let year of filteredFromYears" [value]="year" [tabIndex]="0">
                    {{year}}
                </mat-option>
            </mat-autocomplete>

            <mat-form-field appearance="{{!enableFilter ? 'fill' : 'outline'}}" class="flex-child" color="accent">
                <mat-label>
                    {{ 'year.to' | translate | async }}
                </mat-label>
                <input matInput type="text"
                    [readonly]="!enableFilter"
                    formControlName="yearTo"
                    [matAutocomplete]="yearToAuto">
            </mat-form-field>
            
            <mat-autocomplete #yearToAuto="matAutocomplete">
                <mat-option *ngFor="let year of filteredToYears" [value]="year" [tabIndex]="0">
                    {{year}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </div>
</div>